import { certificatedUser } from '../../Api/ApiUser';
import { sendCertAsEmail } from '../../Api/ApiCertificate';
import { authUser, isNumeric, removeCache, setSnackbar } from '@/helpers';

const initialState = () => ({
    id: null,
    foreignSsn: '',
    isForeignSSN: null,
    hasVerified: authUser(),
    error: false,
    certificate: null,
    verifiedSsn: null,
    hasStarted: false,
    hasInitialized: false,
});

const state = initialState();

const mutations = {
    UPDATE_FIELD(state, field) {
        const key = Object.keys(field)[0];
        state[key] = field[key];
    },
    UPDATE_IS_FOREIGN_SSN: (state, bool) => (state.isForeignSSN = bool),
    SET_CERT: (state, cert) => (state.certificate = cert),
    SET_ERROR: (state, bool) => (state.error = bool),
    SET_VERIFIED: (state, bool) => (state.hasVerified = bool),
    SET_VERIFIED_SSN: (state, ssn) => (state.verifiedSsn = ssn),
    UPDATE_STATE: (state, obj) => (state[obj.key] = obj.value),
    RESET_STATE: (state) => Object.assign(state, initialState()),
};

const actions = {
    async GET_CERTIFICATED_USER({ state, commit }, { id, signature }) {
        // const cache = getCache()
        if (!state.id || state.id !== id) {
            commit('UPDATE_FIELD', { id });
        }

        const payload = {};
        // const national_identity_number = cache ? cache.foreign_national_identity_number : state.foreignSsn

        if ('string' === typeof signature && signature.length > 0) {
            payload.signature = signature;
        }

        // if ('string' === typeof national_identity_number && national_identity_number.length > 0) {
        //     payload.national_identity_number = national_identity_number
        // }

        await certificatedUser(state.id, payload).then((response) => {
            if (typeof response.data === 'object' && response.status === 'Success') {
                // Set the cert
                commit('SET_CERT', response.data);
            } else {
                // Cert not found
                const snackbar = setSnackbar({
                    status: 'Error',
                    message: 'Certifikatet kunde inte hittas',
                });
                snackbar.btnText = 'Tillbaka';
                snackbar.btnHref = () => (location.href = '/');

                commit('GlobalStore/SET_SNACKBAR', snackbar, { root: true });
            }

            // // Don't save or show the snackbar at init.
            // if (state.hasInitialized) {
            //     commit('GlobalStore/SET_SNACKBAR', snackbar, { root: true })
            // }
        });

        // Set init as done.
        await commit('UPDATE_STATE', { key: 'hasInitialized', value: true });
    },
    async SEND_EMAIL({ commit }) {
        return await sendCertAsEmail({
            id: state.id,
        }).then((response) => {
            const snackbar = setSnackbar(response);

            commit('GlobalStore/SET_SNACKBAR', snackbar, { root: true });

            // setTimeout(() => commit('GlobalStore/CLEAR_SNACKBAR', null, {root: true}), 5000)

            return response.status === 'Success';
        });
    },
    RESET_STATE({ commit }) {
        if (removeCache()) {
            commit('RESET_STATE');
        }
    },
};

const getters = {
    GET_CERT: (state) => state.certificate,
    GET_ERROR: (state) => state.error,
    GET_HAS_VERIFIED: (state) => state.hasVerified,
    GET_FOREIGN_SSN: (state) => state.isForeignSSN,
    GET_IS_CONNECTED_USER: (state) => isNumeric(state.id),
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
